import React__default from 'react';
import { __rest, __assign } from '../../_virtual/_tslib.js';
import MessageBubble from '../MessageBubble/index.js';
import AttachmentIcon from './attachment.svg.js';
import styles from './styles.css.js';

var MessageBubbleFile = function MessageBubbleFile(_a) {
  var url = _a.url,
      fileName = _a.fileName,
      onLoad = _a.onLoad,
      rest = __rest(_a, ["url", "fileName", "onLoad"]);

  return React__default.createElement(MessageBubble, __assign({}, rest), React__default.createElement("a", {
    href: url,
    target: "_blank"
  }, React__default.createElement("div", {
    className: styles.fileContainer
  }, React__default.createElement(AttachmentIcon, {
    className: styles.attachmentIcon
  }), React__default.createElement("span", {
    className: styles.fileName
  }, fileName ? fileName : url && url.substring(url.lastIndexOf('/') + 1)))));
};

export default MessageBubbleFile;
//# sourceMappingURL=index.js.map
